import TagManager from 'react-gtm-module';
import { gmtConfig } from '@/env-exports';

interface GAEvent {
  event: string;
  item_id?: string | undefined;
  item_name?: string | undefined;
  item_url?: string | undefined;
  search_term?: string | undefined;
  search_facet?: string | undefined;
  search_click_count?: number | undefined;
  search_facet_click_count?: number | undefined;
  outbound_url?: string | undefined;
  search_result_count?: number | undefined;
  search_count?: number | undefined;
  search_zero_result_count?: number | undefined;
  number_of_duplicates?: number | undefined;
  search_duplicate_count?: number | undefined;
  search_error_message?: string | undefined;
  search_error_count?: number | undefined;
  filter_category?: string | undefined;
  filter_option?: string | undefined;
  search_engaged_count?: number | undefined;
}

const defaultEventValues = {
  item_id: undefined,
  item_name: undefined,
  item_url: undefined,
  search_term: undefined,
  search_facet: undefined,
  search_click_count: undefined,
  search_facet_click_count: undefined,
  outbound_url: undefined,
  search_result_count: undefined,
  search_count: undefined,
  search_zero_result_count: undefined,
  number_of_duplicates: undefined,
  search_duplicate_count: undefined,
  search_error_message: undefined,
  search_error_count: undefined,
  filter_category: undefined,
  filter_option: undefined,
  search_engaged_count: undefined,
};

export const trackGAEvent = (event: GAEvent) => {
  const eventWithContext = {
    ...defaultEventValues,
    ...event,
    app_context: 'global_search',
  };

  TagManager.dataLayer({
    dataLayer: eventWithContext,
    dataLayerName: gmtConfig.config.dataLayerName,
  });
};
